import React from 'react';
import { useLazyLoadQuery } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';
import moment from 'moment';

import Tooltip from 'components/Tooltip';

import { QueryPatientAuditContactTooltipQuery } from './__generated__/QueryPatientAuditContactTooltipQuery.graphql';

export interface QueryPatientAuditContactTooltipProps {
  children: React.ReactNode;
  patientId: string;
}

const QueryPatientAuditContactTooltip = ({ children, patientId }: QueryPatientAuditContactTooltipProps) => {
  const { patientById: patient } = useLazyLoadQuery<QueryPatientAuditContactTooltipQuery>(
    graphql`
      query QueryPatientAuditContactTooltipQuery($id: MongoID!) {
        patientById(_id: $id) {
          createdAt
          auditContact: audit(filter: { modelField: "contact", operation: "update", result: "success" }) {
            timestamp
            id
          }
        }
      }
    `,
    {
      id: patientId,
    },
  );

  const auditLastUpdate = React.useMemo(
    () => moment(get(patient, 'auditContact.timestamp') || get(patient, 'createdAt')).format('lll'),
    [patient],
  );

  return <Tooltip title={`Last updated on ${auditLastUpdate}`}>{children}</Tooltip>;
};

export default QueryPatientAuditContactTooltip;
